/**
 * Generate cryptographically secure random number between 0 and 1
 * Uses Web Crypto API for secure random number generation
 * @returns A random number between 0 and 1
 */
export const getSecureRandom = (): number => {
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0] / (0xffffffff + 1);
};
